import React from "react";
import {
  Clock,
  CalendarCheck,
  Sparkles,
  ShieldCheck,
  Check,
} from "lucide-react";
import { whyChooseUs, promises } from "../mock";

const ICONS = { Clock, CalendarCheck, Sparkles, ShieldCheck };

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="relative py-20 lg:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
              <span className="w-6 h-px bg-sterling-dark" />
              Why Choose Us
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
              Reasons people{" "}
              <span className="italic text-[#daae9c]">choose us</span>
            </h2>
            <p className="mt-5 text-ink/70 leading-relaxed">
              We tailor our service to your needs — with a quiet focus on the
              details that elevate a home from clean to extraordinary.
            </p>

            <div className="mt-8 space-y-3">
              {promises.map((p) => (
                <div key={p} className="flex items-start gap-3">
                  <div className="mt-1 w-5 h-5 rounded-full bg-sterling flex items-center justify-center shrink-0">
                    <Check size={12} className="text-ink" strokeWidth={3} />
                  </div>
                  <span className="text-ink">{p}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {whyChooseUs.map((w, i) => {
                const Icon = ICONS[w.icon] || Sparkles;
                return (
                  <div
                    key={i}
                    className="group relative p-7 bg-white rounded-2xl border border-[#ead8c9] hover:border-sterling-dark hover:-translate-y-1 transition-all hover:shadow-[0_20px_40px_-20px_rgba(138,93,72,0.25)]"
                  >
                    <div className="w-12 h-12 rounded-xl bg-[#faf3eb] group-hover:bg-sterling flex items-center justify-center transition-colors">
                      <Icon size={22} className="text-[#daae9c]" />
                    </div>
                    <h3 className="font-serif-display text-2xl text-ink mt-5">
                      {w.title}
                    </h3>
                    <p className="mt-2 text-sm text-ink/70 leading-relaxed">
                      {w.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
